export default "__VITE_ASSET__JxPO4Mhz__"